export default __webpack_public_path__ + "images/29f1e494b2ee45b2e745c85b442a888f-top40_music.webp";